import { Column } from '@tanstack/react-table'

import Icon from '../Icon'
import { T } from '../Text'

type Props<TData> = {
  autoSortDir: 'asc' | 'desc' | null
  column: Column<TData, unknown>
}
const TableSortIndicator = <TData,>({ autoSortDir, column }: Props<TData>) => {
  if (!column.getCanSort()) {
    return null
  }
  const unappliedSortColorClass = 'text-neutral-400'
  return (
    <T.BodySmall className="text-neutral-600">
      {column.getIsSorted() === 'desc' ? (
        <Icon.FaArrowDown />
      ) : column.getIsSorted() === 'asc' ? (
        <Icon.FaArrowUp />
      ) : autoSortDir === 'desc' ? (
        <Icon.FaArrowDown className={unappliedSortColorClass} />
      ) : (
        <Icon.FaArrowUp className={unappliedSortColorClass} />
      )}
    </T.BodySmall>
  )
}

export default TableSortIndicator
